export default __webpack_public_path__ + "static/media/1974.d8f40a26.png";